export const LANGUAGES_LIST = [
  {label: 'COMMON.ENGLISH', value: 'en'},
  {label: 'COMMON.DEUTSCH', value: 'de'},
];
